import React, { useState } from 'react'
import { bool, object, func } from 'prop-types'
import { Button } from '@mui/material'
import syncLeitor from '../../../services/http/organizacao/syncLeitor'
import SmallTextField from '../../../components/textfield/SmallTextfield'
import SyncronizarOpenButton from './SyncronizarOpenButton'
import BasicModal from '../../../components/shared/modals/BaseModal'
import { notification } from '../../../services/notification'
import { formatCpf } from '../../../utils/cpf/formatCpf'
import { validateCpf } from '../../../utils/cpf/validateCpf'

ModalSincronizar.propTypes = {
  status: bool,
  setStatus: func,
  query: object
}
export default function ModalSincronizar({ status, setStatus }) {
  const [cpf, setCpf] = useState('')
  const [cpfError, setCpfError] = useState('')

  function handleCpfChange(value) {
    const formattedValue = formatCpf(value)
    setCpf(formattedValue)
    if (cpfError) setCpfError('')
  }

  async function sincronizarLeitor(cpf) {
    const cleanCpf = cpf.replace(/\D/g, '')

    if (!validateCpf(cleanCpf)) {
      setCpfError('CPF inválido')
      notification('CPF inválido', 'error')
      return
    }

    try {
      const response = await syncLeitor(cleanCpf)
      if (response.status === 200) {
        notification('Evento de atualização publicado com sucesso', 'success')
        setCpf('')
        setCpfError('')
        setTimeout(() => {
          setStatus(false)
        }, 500)
      }

      return response
    } catch (err) {
      console.log(err)
      notification(`Erro ao sincronizar leitor: ${err.message}`, 'error')
    }
  }

  return (
    <BasicModal
      title="Sincronizar Leitor"
      Caller={SyncronizarOpenButton}
      status={status}
      closeEvent={event => {
        setStatus(event)
      }}
      sx={{
        minWidth: '22vw',
        width: { xs: '100vw', md: '32vw', xl: '22vw' }
      }}
    >
      <form>
        <SmallTextField
          label="CPF do Leitor"
          onChange={({ target }) => handleCpfChange(target.value)}
          value={cpf}
          error={!!cpfError}
          helperText={cpfError}
          placeholder="000.000.000-00"
        />
        <Button
          type="button"
          onClick={() => {
            sincronizarLeitor(cpf)
          }}
          style={{ marginTop: '1rem' }}
          variant="contained"
          disabled={!cpf || cpf.length < 14}
        >
          Sincronizar
        </Button>
      </form>
    </BasicModal>
  )
}
